import React, {ChangeEvent, Component, KeyboardEvent} from 'react';

import {inject, observer} from 'mobx-react';
import I18n from 'app/i18n';

import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import ArticleInterface from 'app/interfaces/articles/ArticleInterface';
import ArticlesContainer from './ArticlesContainer';
import {ArticlePageInterface, ArticlesStore} from 'app/store/ArticlesStore';
import {getPage} from 'app/utils/articles/getPage';
import SearchInput from 'app/components/SearchInput';
import {isArticleNews, isArticlePromotion} from 'app/utils/ArticleHeading';
import ParamsDataInterface from 'app/interfaces/articles/ParamsDataInterface';
import {KEY_ENTER} from 'app/utils/Consts';
import SmartFullPageLoader from 'app/components/reusable/smart_loaders/SmartFullPageLoader';

interface ArticlesByCategoryProps {
    category?: string
    articles?: ArticleInterface[]
    spriteIcon?: string
    type?: string
    slug?: string
    articlesStore?: ArticlesStore
    articleObject?: ArticlePageInterface
    svgIcon?: string
}

@inject('articlesStore')
@observer
export default class ArticlesOfCategory extends Component<ArticlesByCategoryProps> {
    state = {loading: false};

    articleObject: ArticlePageInterface;

    constructor(props: ArticlesByCategoryProps) {
        super(props);
        this.state = {loading: false};
        this.props.articlesStore.init({category: this.props.category, page: getPage() || 1}, this.props.type);
    }

    defineName = (): string => {
        const {slug} = this.props;

        switch (slug) {
        case 'bets':
            return I18n.t('menu_links.bets');
        case 'sport':
            return I18n.t('menu_links.sport');
        case 'casino':
            return I18n.t('menu_links.casino');
        case 'show_egb':
            return I18n.t('show_egb');
        case 'site_news':
            return I18n.t('site_news');
        case 'cup-egb':
            return I18n.t('cup_egb');
        default:
            return I18n.t('menu_links.news');
        }
    };

    getArticleObject = (): ArticlePageInterface => {
        const {articlesStore, slug} = this.props;

        switch (slug) {
        case 'bets':
            return articlesStore.esportsData;
        case 'sport':
            return articlesStore.sportData;
        case 'casino':
            return articlesStore.casinoData;
        case 'show_egb':
            return articlesStore.showEgbData;
        case 'site_news':
            return articlesStore.siteNewsData;
        case 'cup-egb':
            return articlesStore.cupEgbData;
        default:
            return articlesStore.lastData;
        }
    };

    onClickBack = (): void => {
        history.back();
    };

    clearSearch = (): void => this.props.articlesStore.setSearchValue('', this.props.type);

  handleRefreshSearch = (): void => {
      this.clearSearch();
      this.loadData();
  };

  searchHandler = (event: KeyboardEvent<HTMLInputElement>): void => {
      if (event.key === KEY_ENTER) {
          this.loadData(null, event.currentTarget.value);
      }
  };

  searchValueHandler = (event: ChangeEvent<HTMLInputElement>): void => {
      this.props.articlesStore.setSearchValue(event.currentTarget.value, this.props.type);
  };

   loadData = (params?: ParamsDataInterface, searchValue = ''): void => {
       const p = {
           ...params,
           category: this.props.category
       };
       this.props.articlesStore.loadData(p, searchValue, this.props.type);
   };


   render(): React.ReactNode {
       const {loading, data, paginate, searchValue} = this.props.articlesStore.newsData;
       const {category, slug, type, svgIcon} = this.props;

       if (loading) {
           return <SmartFullPageLoader />;
       }

       return (
           <>
               <div className="header-list-promo-articles page-category">
                   <div className="header-list-promo-articles__row">
                       <a className="cursor-pointer" onClick={this.onClickBack}>
                           <SpriteIcon name="#svg-back" size={{height: 8, width: 5}} />
                           {I18n.t('button_back_label')}
                       </a>
                       <p className="header-list-promo-title">
                           <span className="icon">
                               <SpriteIcon name={svgIcon} className="svg-default"/>
                           </span>
                           <span className="name">{this.defineName()}</span>
                       </p>
                   </div>
                   {(isArticlePromotion(type) || isArticleNews(type)) &&
                                <SearchInput
                                    handleKeyPress={this.searchHandler}
                                    handleChange={this.searchValueHandler}
                                    value={searchValue}
                                    onClick={this.handleRefreshSearch}
                                />
                   }
               </div>
               {data?.length > 0 &&
                    <ArticlesContainer
                        paginate={paginate}
                        searchValue={searchValue}
                        category={category}
                        loading={loading}
                        articles={data}
                        slug={slug}
                        type={'news'}
                    />
               }
           </>
       );
   }
}
